import { WorkflowV2NodeDto, ActionNodeDataDto, TriggerNodeDto } from "@babackapp/private-api-client/types";
import { EditorNodeType } from "../nodes/types";

/**
 * Resolves an API node to its corresponding editor node type.
 * This is the single source of truth for mapping API data to UI components.
 */
export function resolveEditorNodeType(apiNode: WorkflowV2NodeDto | TriggerNodeDto): EditorNodeType {
  if (apiNode.type === "trigger") {
    return "trigger";
  }

  if (apiNode.type === "condition") {
    return "condition";
  }

  if (apiNode.type === "action") {
    const actionType = (apiNode.data as ActionNodeDataDto).actionType;
    return resolveActionEditorNodeType(actionType);
  }

  // Fallback (should not happen)
  console.warn("Unknown node type:", apiNode);
  return "action:send_tracking_email";
}

/**
 * Maps API action types to editor node types.
 * Multiple API action types can map to the same editor node type if they share the same UI.
 */
function resolveActionEditorNodeType(actionType: ActionNodeDataDto['actionType']): EditorNodeType {
  const actionTypeMap: Record<string, EditorNodeType> = {
    "send_tracking_email": "action:send_tracking_email",
    "send_return_email": "action:send_return_email",
    "set_order_note": "action:set_order_note",
    "set_order_attribute": "action:set_order_attribute",
    "auto_treat_return": "action:auto_treat_return",
    "update_web": "action:update_web",
    "send_wallet_notification": "action:send_wallet_notification",
    "create_ticket_on_gorgias": "action:create_ticket_on_gorgias",
    "create_ticket_on_zendesk": "action:create_ticket_on_zendesk",
    "send_klaviyo_event": "action:send_klaviyo_event",
    "modify_order_tags": "action:modify_order_tags",
  };

  return actionTypeMap[actionType] || "action:send_tracking_email";
}
